<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <Form-item label="考点名称">
        <Input
          v-model="name"
          style="width:200px"
          placeholder="请输入考点名称关键字"
          clearable
          @keydown.native.prevent.enter="getData"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="getData">搜索</Button>
          <Button icon="md-undo" @click="name = '';getData()">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button type="primary" :to="{name:'QuestionCheckPointEdit'}">新增考点</Button>
    <div class="content">
      <TreeGrid
        :rows="list"
        :columns="columns"
        :maxLevel="4"
        :formatter="formatter"
        childrenProperty="child"
        @onExpand="onExpand"
      >
        <template slot-scope="{ row }" slot="action">
          <Button
            type="text"
            size="small"
            :style="{visibility:row._level<4?'visible':'hidden'}"
            @click="addPoint(row)"
          >新增-</Button>
          <Button
            type="text"
            size="small"
            :to="{name:'QuestionCheckPointEdit',query:{id:row.id,parent_id:row.parent_id,parent_name:row.parent_name}}"
          >编辑-</Button>
          <Button @click="deletePoint(row)" type="text" size="small">删除</Button>
        </template>
      </TreeGrid>
    </div>
  </div>
</template>
<script>
export default {
  name: "QuestionCheckPointManage",
  data() {
    return {
      name: "",
      list: [],
      columns: [
        {
          title: "考点名称",
          key: "name"
        },
        {
          title: "下属考点数量",
          key: "sub_amount",
          align: "center"
        },
        {
          title: "试题数量",
          key: "question_amount",
          align: "center"
        },
        {
          title: "创建人",
          key: "creator",
          align: "center"
        },
        {
          title: "更新时间",
          key: "updated_at_time",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          key: "address",
          width: 140
        }
      ],
      expandIds: []
    };
  },
  async activated() {
    let parentId = this.$route.query.parent_id;
    if (parentId && this.expandIds.indexOf(parentId) < 0) {
      this.expandIds.push(parentId);
    }
    await this.getData();
  },
  methods: {
    formatData(list, parent) {
      if (!list) {
        return;
      }
      list.forEach(row => {
        if (parent) {
          row.parent_name = parent.name;
        }
        if (row.child) {
          this.formatData(row.child, row);
        }
      });
    },
    autoExpand(list) {
      if (!list) {
        return;
      }
      list.forEach(row => {
        if (this.expandIds.indexOf(row.id) >= 0) {
          if (row.child && row.child.length > 0) {
            row._expanded = true;
          }
        }
        if (row.child) {
          this.autoExpand(row.child);
        }
      });
    },
    async getData() {
      let list = await this.$http.get("/api/exam/point", { name: this.name });
      this.formatData(list);
      if (this.expandIds.length > 0) {
        this.autoExpand(list);
      }
      this.list = list;
    },
    async deletePoint(row) {
      if (row.child && row.child.length > 0) {
        await this.$promiseAlert("当前考点含有子考点，不可删除！", {
          type: "warning"
        });
        return;
      }
      if (row.question_amount > 0) {
        await this.$promiseAlert("当前考点已被使用，不可删除！", {
          type: "warning"
        });
        return;
      }
      await this.$promiseConfirm("确定要删除该考点吗？");
      await this.$http.delete("/api/exam/point/" + row.id);
      this.expand_id = row.parent_id;
      await this.getData();
    },
    formatter(row) {
      if (row.updated_at) {
        row.updated_at_time = new Date(parseInt(row.updated_at) * 1000).format(
          "yyyy-MM-dd hh:mm:ss"
        );
      }
    },
    onExpand(row, status) {
      if (status) {
        this.expandIds.push(row.id);
      } else {
        let index = this.expandIds.indexOf(row.id);
        this.expandIds.splice(index, 1);
      }
    },
    async addPoint(row) {
      await this.$promiseConfirm(
        "<div>新增子考点后，当前考点试题将会被转移至子考点，是否确定新增子考点？</div><div style=\"color:#8c8c8c;padding-top:15px;font-size:12px;\">（考点试题转移至子考点后，支持通过考点试题转移，批量转移该考点的试题到其他末级考点下）</div>"
      );
      this.$router.push({
        name: "QuestionCheckPointEdit",
        query: { parent_id: row.id, parent_name: row.name }
      });
    }
  }
};
</script>